import { render, staticRenderFns } from "./text-banner.vue?vue&type=template&id=64dc0f86"
import script from "./text-banner.vue?vue&type=script&lang=js"
export * from "./text-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports